<template>
  <div class="personalCenter">
    <div class="inner">
      <div class="typeContent">
        <p class="title">
          基本信息
        </p>
        <div class="innerContent">
          <div class="item"><p class="leftName">头像：</p> <el-upload
            class="avatar-uploader"
            action="http://www.absign.cn:8080/api/common/files/upload"
            :show-file-list="false"
            accept="image/*"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="zhengmian"></i>
            <span class="t7">修改</span>
          </el-upload></div>
          <div class="item"><p class="leftName">账号：</p><p class="rightT">{{userPhone}}</p><span class="t7" style="margin-left: 15px;cursor: pointer" @click="goChange">修改</span></div>
          <div class="item"><p class="leftName">用户名称：</p><p class="rightT">{{userName}}</p></div>
          <div class="item" v-show="companyName"><p class="leftName">企业名称：</p><p class="rightT">{{companyName?companyName:'暂无'}}</p></div>
          <div class="item" v-show="email!=''"><p class="leftName">邮箱：</p><p class="rightT"><input v-model="email" type="text" placeholder="请输入"></p></div>
          <div class="item"><p class="leftName">当前密码：</p><p class="rightT"><input v-model="oldPas" type="password" placeholder="请输入"></p></div>
          <div class="item"><p class="leftName">新密码：</p><p class="rightT"><input v-model="newpas" type="password" placeholder="请输入"></p></div>
          <div class="item"><p class="leftName">确认密码：</p><p class="rightT"><input v-model="pasAgain" type="password" placeholder="请输入"></p></div>
        </div>
        <div style="height: 100px;background: #ffffff;padding-top: 30px">
          <div class="saveBtn"@click="save">保存</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapActions, mapGetters} from 'vuex'
  export default {
    data(){
      return{
        oldPas:'',
        newpas:'',
        pasAgain:'',
        email:'',
        userName:'',
        companyName:'',
        userPhone:'',
        imageUrl:"",
        fireName:'',
      }
    },
    methods:{
//      photo
      ...mapActions([
        "aUserInfo"
      ]),
      beforeAvatarUpload(){},
      handleAvatarSuccess(data){
        let _this = this;
        this.imageUrl = data.data.imageUrl;
        for(let key in data.data){
          if(key!='imageUrl'){
            _this.fireName = data.data[key]
          }
        }
      },
      getData(){
        let _this = this;
        _this.ajpost('/api/user/findUserInfo',{},function (data) {
          if(data.code !=0){
            _this.$message({
              message: data.msg,
              type: 'warning'
            });
          }else{
            _this.userName = data.data.userName;
            _this.email = data.data.email;
            _this.companyName = data.data.companyName;
            _this.userPhone = data.data.userPhone;
            _this.imageUrl = data.data.userPhoto;
          }
        })
      },
      save(){
        let _this =this;
       if(_this.pasAgain!=_this.newpas){
         _this.$message({
           message: "重复密码不正确",
           type: 'warning'
         });
         return;
       }
       _this.ajpost('/api/user/updateUser',{mail:_this.email,password:_this.oldPas,newPassword:_this.newpas,photo:_this.fireName},function (data) {
         if(data.code!=0){
           _this.$message({
             message: data.msg,
             type: 'warning'
           });
         }else{
           _this.$message({
             message:'编辑成功',
             type: 'success'
           });
           let userData =  JSON.parse(JSON.stringify(_this.gUserInfo))
           userData.userDetailResult.user_photo = _this.fireName;
           _this.aUserInfo(userData)
           _this.getData()
         }
       },function (err) {
         console.log(err)
       })
      },
      goChange(){
        this.$router.push('/changePhone')
      }
    },
    computed:{
      ...mapGetters(['gUserInfo'])
    },
    created(){
      this.getData()
    }
  }
</script>
<style>
  @import "../../assets/less/userRz.css";
  @import "../../assets/less/personal.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/personal.vue